import { Box, keyframes, styled } from "@mui/material";

type BlinkProps = {
  color: "success" | "info" | "warning" | "error" | "primary" | "secondary";
  size?: "small" | "large";
};

const BlinkAnimation = keyframes`
  0% {
    transform: scale(.8);
    opacity: 1;
  }
  100% {
    transform: scale(2.4);
    opacity: 0;
  }`;

const Blink = styled(Box)<BlinkProps>(({ theme, color, size = "small" }) => {
  let palleteColor = theme.palette.primary;
  switch (color) {
    case "success":
      palleteColor = theme.palette.success;
      break;
    case "info":
      palleteColor = theme.palette.info;
      break;
    case "warning":
      palleteColor = theme.palette.warning;
      break;
    case "error":
      palleteColor = theme.palette.error;
      break;
    case "primary":
      palleteColor = theme.palette.primary;
      break;
    case "secondary":
      palleteColor = theme.palette.secondary;
      break;
  }
  return {
    position: "relative",
    width: size === "small" ? 8 : 16,
    height: size === "small" ? 8 : 16,
    borderRadius: "50%",
    backgroundColor: palleteColor.main,
    color: palleteColor.main,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: `${BlinkAnimation} 2s infinite ease-in-out`,
      border: "1px solid currentColor",
      content: '""',
    },
  };
});

export default Blink;
